import { Reveal } from "./Reveal";
import { TESTIMONIALS } from "../../data";
import { Quote } from "lucide-react";

export const Testimonials = () => (
  <section
    id="testimonials"
    data-testid="testimonials-section"
    className="relative bg-[#0a0a0a] py-24 md:py-40"
  >
    <div className="mx-auto max-w-[1400px] px-5 md:px-10">
      <Reveal>
        <div className="flex items-end justify-between gap-6 mb-14">
          <div>
            <span className="text-xs uppercase tracking-[0.3em] text-[#e5ff00]">
              Results
            </span>
            <h2 className="mt-5 font-display uppercase text-4xl md:text-6xl leading-[0.9]">
              From the floor
            </h2>
          </div>
        </div>
      </Reveal>

      <div className="grid md:grid-cols-3 gap-4">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name} delay={i * 0.1}>
            <figure
              data-testid={`testimonial-${i}`}
              className="h-full flex flex-col justify-between rounded-xl border border-white/10 bg-[#121212] p-8 hover:border-white/25 transition-colors duration-300"
            >
              <Quote className="text-[#e5ff00]" size={28} />
              <blockquote className="mt-6 text-white/85 text-lg leading-relaxed">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-8 pt-6 border-t border-white/10">
                <div className="font-display uppercase text-lg text-white">
                  {t.name}
                </div>
                <div className="text-xs uppercase tracking-[0.18em] text-white/50 mt-1">
                  {t.role}
                </div>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
